export function requiredField(key) {
    return value => {
        if (!value[key]) {
            return { [key]: '{field} is required' }
        }

        return {}
    }
}

export function requiredListSelection(key, list) {
    return value => {
        if (!list.find(i => i === value[key])) {
            return { [key]: 'Please make a selection' }
        }

        return {}
    }
}

export function validate(value, validators) {
    const errors = validators.reduce((acc, v) => Object.assign(acc, v(value)), {})
    return { valid: Object.keys(errors).length === 0, errors }
}

export function conditionalValidator(key, validators) {
    return value => {
        if (value[key]) {
            const { errors } = validate(value, validators)
            return errors
        }

        return {}
    }
}

export function translate(errors, fields) {
    if (!errors) {
        return
    }

    fields ??= {}

    Object.keys(errors).forEach(key => {
        const value = errors[key]

        if (Array.isArray(value)) {
            errors[key] = value.map(v => v.replaceAll('{field}', fields?.[key] || key))
        } else {
            errors[key] = value.replaceAll('{field}', fields?.[key] || key)
        }
    })
}

export function translateErrors(errors, fields) {
    Object.keys(errors).forEach(key => {
        let parts = parseKey(key)

        if (parts[0] === '$') {
            parts = parts.slice(1)
        }

        if (parts.length > 1) {
            let target = errors
            let names = fields

            parts.slice(0, -1).forEach(p => {
                if (!p.match(/^(\d+)$/)) {
                    names = fields[p] ?? {}
                }

                target = target[p] ??= {}
            })

            const last = parts[parts.length - 1]

            target[last] = errors[key].map(v => v.replaceAll('{field}', names[last] || last))

            delete errors[key]
        } else {
            const value = errors[key]

            if (Array.isArray(value)) {
                errors[key] = value.map(v => v.replaceAll('{field}', fields[key] || key))
            } else {
                errors[key] = value.replaceAll('{field}', fields[key] || key)
            }
        }
    })
}

function parseKey(key) {
    const parts = []
    let mark = 0
    let index = 0

    while (index < key.length) {
        if (key[index] === '.') {
            if (mark !== index) {
                parts.push(key.slice(mark, index))
            }
            mark = ++index
            continue
        }

        if (key[index] === '[') {
            if (mark !== index) {
                parts.push(key.slice(mark, index))
            }

            mark = ++index

            if (key[index] === "'") {
                // quoted string
                mark = ++index

                let escaped = false

                while (index < key.length) {
                    if (key[index] === '\\') {
                        escaped = !escaped
                    } else if (escaped) {
                        escaped = false
                    } else if (key[index] === "'") {
                        if (mark !== index) {
                            // TODO: unescape
                            parts.push(key.slice(mark, index))
                        }
                        mark = ++index
                        break
                    }

                    index++
                }
            }

            while (index < key.length) {
                if (key[index] === ']') {
                    if (mark !== index) {
                        parts.push(key.slice(mark, index))
                    }
                    mark = ++index
                    break
                }

                index++
            }

            continue
        }

        index++
    }

    if (mark < key.length) {
        parts.push(key.slice(mark))
    }

    return parts
}
